// Visual selection card for choice-based questions (current system, bill range, etc.)
export default function CalcChoiceCard({
  testId,
  icon: Icon,
  title,
  description,
  selected,
  onClick,
  compact = false,
}) {
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      className={`relative text-left rounded-2xl border-2 transition-all duration-200 w-full h-full ${
        compact ? "p-4" : "p-5 sm:p-6"
      } ${
        selected
          ? "border-[#10B981] bg-[#10B981]/5 shadow-[0_10px_30px_-15px_rgba(16,185,129,0.4)]"
          : "border-[#E2E8F0] bg-white hover:border-[#0B132B]/40 hover:shadow-md"
      }`}
    >
      {selected && (
        <span className="absolute top-3 right-3 inline-flex h-5 w-5 items-center justify-center rounded-full bg-[#10B981] text-white text-[10px] font-bold">
          ✓
        </span>
      )}
      {Icon && (
        <span
          className={`inline-flex h-10 w-10 items-center justify-center rounded-xl mb-3 transition-colors ${
            selected ? "bg-[#10B981] text-white" : "bg-[#F1F5F9] text-[#0B132B]"
          }`}
        >
          <Icon className="h-5 w-5" strokeWidth={1.8} />
        </span>
      )}
      <p className="font-heading font-semibold text-[#0B132B] text-[15px] leading-tight">{title}</p>
      {description && <p className="text-xs text-[#475569] mt-1.5 leading-relaxed">{description}</p>}
    </button>
  );
}
